/* eslint-disable react/prop-types */
import React from 'react';
import Modal from '@mui/material/Modal';
import { style } from './style';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { Card } from '@mui/material';
import { CardContent } from '@mui/material';
import { Typography } from '@mui/material';
import { CardActions } from '@mui/material';
import { Button } from '@mui/material';
const BasicModal = ({
    open,
    children,
    handleClose,
    extraStyle = {},
    ...restProps
}) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            {...restProps}
        >
            <Box sx={{ ...style, ...extraStyle }}>
                {children}
            </Box>
        </Modal>
    );
};
BasicModal.propTypes = {
    open: PropTypes.bool,
    closeIcon: PropTypes.bool,
    handleClose: PropTypes.func,
    extraStyle: PropTypes.object
};
export default BasicModal;

export const ConfirmationDialog = ({ open, okBtnText = 'Verify', message = 'Please confirm', handleClose, handleVerified }) => {
    return <BasicModal open={open} handleClose={handleClose}>
        <Card className='m-6'>
            <CardContent>
                <Typography variant='body1'>
                    {message}
                </Typography>
            </CardContent>
            <CardActions className='flex justify-end m-1'>
                <Button size="small" variant='outlined' onClick={handleClose}>Cancel</Button>
                <Button size="small" variant='contained' onClick={handleVerified}>{okBtnText}</Button>
            </CardActions>
        </Card>
    </BasicModal>;
};